import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject9(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Costos");
    await safeDeleteSheet(context, "Ganancias");

    // ─── SHEET 1: Costos ───
    const sheet1 = context.workbook.worksheets.add("Costos");

    // Title
    sheet1.getRange("A1").values = [["Tienda de Caramelo"]];
    sheet1.getRange("A1:E1").merge();
    sheet1.getRange("A1").format.font.name = "Comic Sans MS";
    sheet1.getRange("A1").format.font.size = 26;
    sheet1.getRange("A1").format.font.color = "#E91E8E";
    sheet1.getRange("A1").format.font.italic = true;
    sheet1.getRange("A1").format.horizontalAlignment = "Center";
    sheet1.getRange("A1").format.rowHeight = 48;

    // Subtitle
    sheet1.getRange("A2").values = [["Costos de Sabor (por libra)"]];
    sheet1.getRange("A2:E2").merge();
    sheet1.getRange("A2").format.font.bold = true;
    sheet1.getRange("A2").format.font.size = 12;
    sheet1.getRange("A2").format.horizontalAlignment = "Center";

    const headers1 = ["Sabores", "Costo", "Precio fijo", "Precio", "Márgen"];

    // Note: "Choco" used intentionally — Task 1 asks student to replace with "Chocolate"
    const data1: (string | number)[][] = [
      ["Choco de arándanos", 2.32, 1.8, 6.5, 4.18],
      ["Cheesecake de caramelo", 3.25, 0.96, 6.37, 3.12],
      ["Café de moca", 2.56, 1.28, 5.84, 3.28],
      ["Trozo de vainilla", 2.59, 1.25, 5.83, 3.24],
      ["Rompe muelas de menta", 2.05, 1.8, 5.74, 3.69],
      ["Derroche de cielo de frutas", 2.14, 1.65, 5.68, 3.54],
      ["Trufa de nuez y maní", 1.98, 1.8, 5.55, 3.57],
      ["Derroche de cielo de choco", 2.28, 1.34, 5.34, 3.06],
      ["Derroche de cielo de nuez", 2.36, 1.2, 5.2, 2.84],
      ["Jarabe para panqueque de palomitas de maiz", 1.78, 1.8, 4.99, 3.21],
      ["Galletas de animalitos", 1.77, 1.8, 4.96, 3.19],
      ["Pavimento de caramelo", 1.76, 1.8, 4.93, 3.17],
      ["Yogurt cubierto de anacardo", 1.79, 1.5, 4.48, 2.69],
      ["Dona de canela", 1.54, 1.8, 4.32, 2.78],
      ["Choco de frijol negro", 1.46, 1.8, 4.09, 2.63],
      ["Menta choco cereza", 1.35, 1.8, 3.78, 2.43],
      ["Pistaches y nueces", 1.28, 1.8, 3.59, 2.31],
      ["Choco picante", 1.25, 1.8, 3.5, 2.25],
      ["Sopa enlatada de soufflé de Campbell", 1.11, 1.8, 3.11, 2],
      ["Sorbete de tarta agría", 1.5, 1.03, 3.05, 1.55],
      ["Cono de galleta de frambuesa", 1.08, 1.8, 3.03, 1.95],
      ["Té verde hierba de trigo", 0.28, 5.86, 1.93, 1.65],
      ["Crema de nieve de vainilla", 0.35, 2.3, 1.16, 0.81],
    ];

    const table1 = sheet1.tables.add("A3:E3", true);
    table1.name = "CostosSabor";
    table1.getHeaderRowRange().values = [headers1];
    table1.style = "TableStyleMedium7";
    table1.rows.add(undefined, data1);

    // Pink theme
    const headerRange1 = table1.getHeaderRowRange();
    headerRange1.format.fill.color = "#E91E8E";
    headerRange1.format.font.color = "#FFFFFF";
    headerRange1.format.font.bold = true;

    const bodyRange1 = table1.getDataBodyRange();
    bodyRange1.format.fill.color = "#FDDDE6";

    sheet1.tabColor = "#E91E8E";
    sheet1.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── SHEET 2: Ganancias ───
    const sheet2 = context.workbook.worksheets.add("Ganancias");

    // Title
    sheet2.getRange("A1").values = [["Tienda de Caramelo"]];
    sheet2.getRange("A1:G1").merge();
    sheet2.getRange("A1").format.font.name = "Comic Sans MS";
    sheet2.getRange("A1").format.font.size = 26;
    sheet2.getRange("A1").format.font.color = "#E91E8E";
    sheet2.getRange("A1").format.font.italic = true;
    sheet2.getRange("A1").format.horizontalAlignment = "Center";
    sheet2.getRange("A1").format.rowHeight = 48;

    // Subtitle
    sheet2.getRange("A2").values = [["Costos de sabor (por libra)"]];
    sheet2.getRange("A2:G2").merge();
    sheet2.getRange("A2").format.font.bold = true;
    sheet2.getRange("A2").format.font.size = 12;
    sheet2.getRange("A2").format.horizontalAlignment = "Center";

    const headers2 = [
      "Sabores", "Costo", "Precio", "Ventas",
      "Gastos", "Ingresos", "Ganancia Total",
    ];

    const data2: (string | number)[][] = [
      ["Derroche de cielo de frutas", 2.14, 5.68, 662, 1416.68, 3760.16, 2343.48],
      ["Derroche de cielo de nuez", 2.36, 5.20, 592, 1397.12, 3078.40, 1681.28],
      ["Trozo de vainilla", 2.59, 5.83, 264, 683.76, 1539.12, 855.36],
      ["Jarabe para panqueque de palomitas de maíz", 1.78, 4.99, 264, 469.92, 1317.36, 847.44],
      ["Pavimento de caramelo", 1.76, 4.93, 260, 457.60, 1281.80, 824.20],
      ["Dona de canela", 1.54, 4.32, 264, 406.56, 1140.48, 733.92],
      ["Café de moca", 2.56, 5.84, 204, 522.24, 1191.36, 669.12],
      ["Choco de frijol negro", 1.46, 4.09, 233, 340.18, 952.97, 612.79],
      ["Pistaches y nueces", 1.28, 3.59, 260, 332.80, 933.40, 600.60],
      ["Choco de arándanos", 2.32, 6.50, 143, 331.76, 929.50, 597.74],
      ["Choco picante", 1.25, 3.50, 260, 325.00, 910.00, 585.00],
      ["Derroche de cielo de choco", 2.28, 5.34, 178, 405.84, 950.52, 544.68],
      ["Crema de nieve de vainilla", 0.35, 1.16, 662, 231.70, 767.92, 536.22],
      ["Rompemuelas de menta", 2.05, 5.74, 140, 287.00, 803.60, 516.60],
      ["Trufa de nuez y maní", 1.98, 5.55, 143, 283.14, 793.65, 510.51],
      ["Cheesecake de caramelo", 3.25, 6.37, 154, 500.50, 980.98, 480.48],
      ["Galletas de animalitos", 1.77, 4.96, 143, 253.11, 709.28, 456.17],
      ["Cono de galleta de frambuesa", 1.08, 3.03, 233, 251.64, 705.99, 454.35],
      ["Menta choco cereza", 1.35, 3.78, 178, 240.30, 672.84, 432.54],
      ["Yogurt cubierto de nacarado", 1.79, 4.48, 154, 275.66, 689.92, 414.26],
      ["Té verde hierba de trigo", 0.28, 1.93, 189, 52.92, 364.77, 311.85],
      ["Sopa enlatada de soufflé de Campbell", 1.11, 3.11, 140, 155.40, 435.40, 280.00],
      ["Sorbete de tarta agría", 1.50, 3.05, 174, 261.00, 530.70, 269.70],
    ];

    const table2 = sheet2.tables.add("A3:G3", true);
    table2.name = "GananciasSabor";
    table2.getHeaderRowRange().values = [headers2];
    table2.style = "TableStyleMedium7";
    table2.rows.add(undefined, data2);

    // Green header theme for Ganancias
    const headerRange2 = table2.getHeaderRowRange();
    headerRange2.format.fill.color = "#00B050";
    headerRange2.format.font.color = "#FFFFFF";
    headerRange2.format.font.bold = true;

    const bodyRange2 = table2.getDataBodyRange();
    bodyRange2.format.fill.color = "#FDDDE6";

    sheet2.tabColor = "#00B050";
    sheet2.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── Chart helper data (columns I-K, behind the chart) ───
    const chartHeaders: (string | number)[][] = [["", "Gastos", "Ingresos"]];
    const chartRows: (string | number)[][] = data2.map((row) => [
      row[0],
      row[4],
      row[5],
    ]);
    const chartData = [...chartHeaders, ...chartRows];
    sheet2.getRange(`I3:K${3 + data2.length}`).values = chartData;

    // Create chart with rows as series (wrong orientation — student fixes in Task 4)
    const chart = sheet2.charts.add(
      Excel.ChartType.columnClustered,
      sheet2.getRange(`I3:K${3 + data2.length}`),
      Excel.ChartSeriesBy.rows,
    );
    chart.title.text = "Sabores, Gastos, Ingresos y Ganancias";
    chart.title.format.font.color = "#E91E8E";
    chart.setPosition("H3");
    chart.height = 400;
    chart.width = 650;
    chart.legend.position = Excel.ChartLegendPosition.bottom;

    await context.sync();

    // Activate first sheet
    sheet1.activate();
    sheet1.getRange("A1").select();

    await context.sync();
  });
}
